__turbopack_context__.v({
  "container": "_6Z5ZUq_container",
  "dateAndTagSeperator": "_6Z5ZUq_dateAndTagSeperator",
  "newsDateStyles": "_6Z5ZUq_newsDateStyles",
  "newsTagStyles": "_6Z5ZUq_newsTagStyles",
  "pageMainTitle": "_6Z5ZUq_pageMainTitle",
  "shareBtnSyles": "_6Z5ZUq_shareBtnSyles",
  "timeAndTimeIconSeperator": "_6Z5ZUq_timeAndTimeIconSeperator",
  "timeText": "_6Z5ZUq_timeText",
  "toasTextStyles": "_6Z5ZUq_toasTextStyles",
});
